import { ProductState } from '@/store/types';

const stateBuilder = (): ProductState => {
  return {
    products: [],
    search: '',
  };
};

const state = stateBuilder;

export default state;
